import React, { ChangeEvent, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CForm,
  CFormInput,
  CFormSelect,
  CRow,
  CTabContent,
} from '@coreui/react-pro'
import {
  $achievement,
  $createAchievementDone,
  resetCreateAchievementDone,
  setAchievement,
  submitCreateAchievement,
} from './model'
import { useStore } from 'effector-react'
import { ACHIEVEMENT_NAME_OPTIONS } from '../constants'
import { path } from '../../../../libs'

export const CreateAchievement = () => {
  const achievement = useStore($achievement)
  const createAchievementDone = useStore($createAchievementDone)
  const navigate = useNavigate()

  useEffect(() => {
    if (createAchievementDone) {
      navigate(path.copytrade.achievements.entry())
      resetCreateAchievementDone()
    }
  }, [createAchievementDone, navigate])

  const handleChange = (
    event: ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => {
    let value

    if (event.currentTarget.type === 'checkbox') {
      value = (event.currentTarget as HTMLInputElement).checked
    } else if (event.currentTarget.type === 'file') {
      value = (event.currentTarget as HTMLInputElement).files![0]
    } else {
      value = event.currentTarget.value
    }

    setAchievement({
      ...achievement,
      [event.currentTarget.name]: value,
    })
  }

  return (
    <div>
      <CCard className="mb-4">
        <CCardHeader className="d-sm-flex justify-content-between align-items-center">
          <strong>Create achievements</strong>
        </CCardHeader>
        <CCardBody>
          <CTabContent className="pt-3">
            <CForm>
              <CRow className="mb-3">
                <CCol sm={4}>
                  <CFormSelect
                    id="name"
                    name="name"
                    value={achievement.name}
                    onChange={handleChange}
                    label="Name"
                    options={ACHIEVEMENT_NAME_OPTIONS}
                  />
                </CCol>
              </CRow>
              <CRow className="mb-3">
                <CCol sm={4}>
                  <CFormInput
                    type="file"
                    id="file"
                    name="file"
                    label="Choose image"
                    onChange={handleChange}
                  />
                </CCol>
              </CRow>
              <CRow className="mb-3">
                <CCol sm={4}>
                  <CFormInput
                    type="text"
                    id="priority"
                    name="priority"
                    value={achievement.priority}
                    onChange={handleChange}
                    label="Priority"
                  />
                </CCol>
              </CRow>
              <CRow className="mb-3">
                <CCol sm={4}>
                  <CFormInput
                    type="date"
                    id="enabledAt"
                    name="enabledAt"
                    value={achievement.enabledAt}
                    onChange={handleChange}
                    label="Enabled at"
                  />
                </CCol>
              </CRow>
              <CButton
                className="mb-3"
                onClick={() => {
                  submitCreateAchievement(achievement)
                }}
              >
                Save
              </CButton>
            </CForm>
          </CTabContent>
        </CCardBody>
      </CCard>
    </div>
  )
}
